import { useQuery } from '@tanstack/react-query';
import { requestTypeOptions } from 'keys/requestTypes';
import { queryClient as qc } from 'keys'
import { getTicketTypeCountsFetch } from 'store/middlewares/tickets.crud';

const useTabs = () => {
    const ticketTypeCounts = useQuery({
        queryKey: qc.ticketTypeCounts,
        queryFn: async () => {
            let { data } = await getTicketTypeCountsFetch()
            data = data.ticket_type_counts
            data.ALL = { count: data.count }
            return data
        },
    })

    const tabs = [
        { id: "ALL", name: "הכל", active: true },
        ...requestTypeOptions].map((item) => ({
            id: item.id,
            label: item.name,
            width: "80px",
            badge: ticketTypeCounts.data?.[item.id]?.count ? ticketTypeCounts.data?.[item.id]?.count : "",
            active: item.active
        }))

    return tabs
}

export default useTabs
